// Primary currency: Nigerian Naira (NGN)
const ngnFormatter = new Intl.NumberFormat("en-NG", {
  style: "currency",
  currency: "NGN",
  maximumFractionDigits: 0,
});

const ngnFormatterWithDecimals = new Intl.NumberFormat("en-NG", {
  style: "currency",
  currency: "NGN",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** Format a number as Nigerian Naira. Default rounds to integer. */
export function fmt(amount, { decimals = false } = {}) {
  if (amount == null || isNaN(amount)) return "₦0";
  return decimals ? ngnFormatterWithDecimals.format(amount) : ngnFormatter.format(amount);
}

/** Compact form — e.g. ₦1.8B+ */
export function fmtCompact(amount) {
  if (amount == null || isNaN(amount)) return "₦0";
  const abs = Math.abs(amount);
  if (abs >= 1_000_000_000_000) return `₦${(amount / 1_000_000_000_000).toFixed(1)}T`;
  if (abs >= 1_000_000_000) return `₦${(amount / 1_000_000_000).toFixed(1)}B`;
  if (abs >= 1_000_000) return `₦${(amount / 1_000_000).toFixed(1)}M`;
  if (abs >= 1_000) return `₦${(amount / 1_000).toFixed(1)}K`;
  return `₦${amount.toFixed(0)}`;
}
